<section class="database-page">
	<section class="content-area">
		<lvr-tabs class="tab-content-container">
			<lvr-tab [icon]="'analytics'" [route]="tabRoute(activeTab())" [isActive]="true" [showDestroyButton]="false">
				Listen
			</lvr-tab>
		</lvr-tabs>

		<section class="tab-content border-top">
			@switch (activeTab()) {
				@case ('assignments') {
					<section>
						<lvr-database-assignments-list></lvr-database-assignments-list>
					</section>
				}
				@case ('institutions') {
					<section>
						<lvr-database-institutions-list></lvr-database-institutions-list>
					</section>
				}
				@case ('leks') {
					<section>
						<lvr-database-lek-list></lvr-database-lek-list>
					</section>
				}
			}
		</section>
	</section>

	<lvr-tabs class="vertical vertical-tab-group">
		@for (tab of tabs(); track tab.id) {
			<lvr-tab
				[showDestroyButton]="false"
				[isActive]="isTabActive(tab.id)"
				[icon]="tab.icon"
				[route]="tabRoute(tab.id)"
			>
				{{ tab.labelKey | transloco }}
			</lvr-tab>
		}
	</lvr-tabs>
</section>
